import { BuildingIcon, WaterIcon } from "../../iconSet/IconSet";

const FloodForecastMapRightSideButtons = () => {
  return (
    <div className="forecast-map-right-side-btn-container">
      <div className="forecast-map-right-btns" style={{cursor:"pointer",marginBottom:"10px"}} onClick={() => {

      }}>
        <BuildingIcon
          width="1rem" color="var(--color-text)"
        />
      </div>
      <div className="forecast-map-right-btns" style={{cursor:"pointer"}} onClick={() => {}}>
        <WaterIcon
          width="1rem" color="var(--color-text)"
        />
      </div>
    </div>
  );
};

export default FloodForecastMapRightSideButtons;
